import type {
  CheckBoxEventValue,
  InterstateOnChangeEvent
} from "@dealer-center/core-components";
import { CheckBox } from "@dealer-center/core-components";
import type { booleanInputs } from "..";
import { configItemContext } from "..";
import type {
  InventoryListingConfig,
  InventoryListingConfigKeys
} from "@dealer-center/ddc-pages-inventory-config-interface";
import styled from "styled-components";
import { useContext } from "react";
import {
  StyledIconInfoOutline,
  StyledImport,
  StyledImportedText,
  StyledInputWrapper
} from "./styles";

interface PagesInventoryConfigUiConfigDispayInputCheckBox {
  item: booleanInputs;
}
const StyledCheckBoxList = styled(CheckBox)``;

const shouldCheckBoxBeChecked = (
  item: InventoryListingConfigKeys,
  curentConfig: InventoryListingConfig
): boolean => (curentConfig[item] ? true : false);

export const ConfigCheckBox = ({
  item
}: PagesInventoryConfigUiConfigDispayInputCheckBox) => {
  const {
    curentConfig,
    setCurrentConfigValue,
    importedConfig,
    selectedConfig
  } = useContext(configItemContext);
  const currentConfigItem = curentConfig[item.dataIndex] as string;
  const importedConfigItem = importedConfig?.[item.dataIndex] as string;
  const selectedConfigItem = selectedConfig?.[item.dataIndex] as string;
  const isUsingImportedValue =
    currentConfigItem === importedConfigItem &&
    currentConfigItem !== selectedConfigItem;

  const onChange = (e: InterstateOnChangeEvent<CheckBoxEventValue>) => {
    const value = e.target.value?.checked ?? false;
    setCurrentConfigValue({
      key: item.dataIndex,
      value
    });
  };
  return (
    <StyledInputWrapper>
      <StyledCheckBoxList
        checked={shouldCheckBoxBeChecked(item.dataIndex, curentConfig)}
        id={item.dataIndex}
        label={item.label}
        value={item.dataIndex}
        onChange={onChange}
      />
      {isUsingImportedValue && (
        <StyledImport>
          <StyledIconInfoOutline title="Using imported value" />
          <StyledImportedText>Using imported value</StyledImportedText>
        </StyledImport>
      )}
    </StyledInputWrapper>
  );
};
